var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg35(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.6247H24V5.56309H17.4946V1.375H6.50531V5.56309H0L0 23.6247ZM22.5937 13.2895C22.5937 14.7682 21.3907 15.9712 19.912 15.9712H14.2132V13.3549H9.78675V15.9712H4.08792C2.60925 15.9713 1.40625 14.7683 1.40625 13.2895V6.96934H22.5937V13.2895ZM11.193 17.3775H12.807V17.7807C12.807 18.2256 12.4449 18.5876 12 18.5876C11.5551 18.5876 11.193 18.2256 11.193 17.7807V17.3775ZM11.193 15.9713V14.7611H12.807V15.9712H11.193V15.9713ZM7.91156 2.78125H16.0883V5.56309H7.91156V2.78125ZM1.40625 22.2185V16.3724C2.12461 16.9981 3.06277 17.3775 4.08792 17.3775H9.78675V17.7807C9.78675 19.001 10.7796 19.9938 12 19.9938C13.2203 19.9938 14.2132 19.001 14.2132 17.7807V17.3775H19.912C20.9372 17.3775 21.8754 16.9981 22.5937 16.3724V22.2185H1.40625Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg35);
export default __webpack_public_path__ + "static/media/35.2c4e818ae5d5dd1067429b174b09878a.svg";
export { ForwardRef as ReactComponent };